import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';

import { apiBasePath, apiName } from 'assets/constants';
import { TaxaData } from './types/taxa-data.types';

interface TaxaDataProps {
  kitId?: string;
  kitType: string;
  relativeAbundanceLimit?: number;
}

export const getTaxaData = async (
  kitId: string,
  relativeAbundanceLimit?: number,
) => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/results/microbiome/${kitId}?relativeAbundanceLimit=${relativeAbundanceLimit}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.MICROBIOME,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        kitId,
        relativeAbundanceLimit,
      },
    },
  );
  return response?.result;
};

const useTaxaData = ({
  kitId,
  kitType,
  relativeAbundanceLimit,
}: TaxaDataProps) => {
  const taxaDataQuery = useSuspenseQuery<TaxaData[]>({
    queryKey: [apiName, `${kitType}InsightsBacteria`, kitId],
    queryFn: async () =>
      !!kitId && (await getTaxaData(kitId, relativeAbundanceLimit)),
  });
  return taxaDataQuery;
};

export default useTaxaData;
